import { PropTypes } from 'prop-types';
import React, { Component, forwardRef, useImperativeHandle } from 'react';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { FileType } from '../../views/claimDetail/models';
import { TextArea } from '../formValidation';
import * as utils from '../utils';
import FileReader from './FileReader';

class FileUploadForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: props.file,
      fileType: props.fileType,
    };
  }

  getFileReader = () => {
    return (
      <FileReader
        handleFiles={this.handleFiles}
        fileType={utils.toString(FileType, this.state.fileType)}
        title="Select"
      />
    );
  };

  handleFiles = (files) => {
    let fileTypeValid = false;

    if (/image/.test(files.fileList[0].type)) {
      fileTypeValid = true;
      this.setState({ fileType: FileType.image });
    } else if (/video/.test(files.fileList[0].type)) {
      fileTypeValid = true;
      this.setState({ fileType: FileType.video });
    } else if (files.fileList[0].type === 'application/pdf') {
      fileTypeValid = true;
      this.setState({ fileType: FileType.document });
    }

    if (fileTypeValid) {
      this.setState({ file: files }, () => {
        // propagate into RHF state
        if (this.props.formApi && this.props.formApi.setValue) {
          this.props.formApi.setValue('file', files.fileList[0], { shouldDirty: true });
        }
      });
    }
  };

  render() {
    const intl = this.props.intl;
    return (
      <div>
        <div className="form-group">
          <label htmlFor="file">{intl.formatMessage({ id: 'file' })}</label>
          <div className="form-file-preview">
            {this.state.fileType === FileType.image ? (
              <img src={this.state.file.base64} alt={this.state.file.fileList[0].name} />
            ) : (
              <span className="badge badge-pill badge-primary">
                {this.state.file.fileList[0].name}
              </span>
            )}
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="description">{intl.formatMessage({ id: 'description' })}</label>
          <Controller
            name="description"
            render={({ field }) => (
              <TextArea
                input={field}
                id="description"
                type="text"
                className="form-control"
                placeholder="Enter description"
              />
            )}
          />
        </div>
      </div>
    );
  }
}

FileUploadForm.propTypes = {
  file: PropTypes.shape({}).isRequired,
  fileType: PropTypes.oneOf([FileType.image, FileType.video, FileType.document]).isRequired,
  intl: PropTypes.shape({}).isRequired,
  formApi: PropTypes.shape({ setValue: PropTypes.func }),
};

// Wrap with RHF provider and expose imperative submit
const FileUploadFormRHF = forwardRef(function FileUploadFormRHF(
  { onSubmit, initialValues, ...rest },
  ref
) {
  const api = useForm({ defaultValues: initialValues || {} });

  useImperativeHandle(ref, () => ({ submit: () => api.handleSubmit(onSubmit)() }));

  const Inner = injectIntl((props) => (
    <FormProvider {...api}>
      <form onSubmit={api.handleSubmit(onSubmit)}>
        <FileUploadForm {...props} formApi={api} />
      </form>
    </FormProvider>
  ));

  return <Inner {...rest} />;
});

export default FileUploadFormRHF;
